module.exports = __webpack_public_path__ + "ploni-aaa-200.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-200.otf
// module id = 1196
// module chunks = 10